import axios from "axios";
import firebase, { FS } from "./firebase";

export const fetchAppointmentDetailsService = async ({ appointmentId, practitionerId, clientId }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_DB4_APPOINTMENT}?`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    params: {
      appointmentId,
      practitionerId,
      clientId,
    },
  });
};

export const fetchAppointmentsService = async ({ fromDate, toDate, pages }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_DB4_APPOINTMENTS}?fromDate=${fromDate}&toDate=${toDate}&pages=${pages}`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
  });
};

export const sendDB4Service = async ({
  appointmentId,
  patientEmail,
  patientFullName,
  practitionerFullName,
  dateOfService,
  serviceItems,
}) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_EMAIL_DB4}`,
    {
      appointmentId,
      patientEmail,
      patientFullName,
      practitionerFullName,
      dateOfService,
      serviceItems,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const sendAppointmentNotificationService = async ({ appointment }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_EMAIL_APPOINTMENT_TO_DOCTOR}`,
    {
      log: "appointment_to_doctor_notification",
      appointmentId: appointment.id,
      to: `${appointment.practitionerEmail}, ${appointment.referrerEmail}`,
      subject: `Telehealth Dial-in for ${appointment.patientFirstName} ${appointment.patientSurname}`,
      data: appointment,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const sendPatientNotificationService = async ({ appointment }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_EMAIL_APPOINTMENT_TO_PATIENT}`,
    {
      log: "appointment_to_patient_notification",
      appointmentId: appointment.id,
      to: `${appointment.patientEmail}`,
      subject: `Telehealth Dial-in for ${appointment.patientFirstName} ${appointment.patientSurname}`,
      data: appointment,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const getCoreplusPreload = async () => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(process.env.REACT_APP_COREPLUS_PRELOAD, {
    headers: { Authorization: `Bearer ${userIdToken}` },
  });
};

export const getSpecialists = async () => {
  const query = FS.query(FS.collection(firebase.modularFirestore(), "specialists"));
  const specialistsSnapshot = await FS.getDocs(query);
  return {
    specialists: specialistsSnapshot.docs.reduce((prev, doc) => {
      return { ...prev, [doc.id]: { ...doc.data(), id: doc.id } };
    }, {}),
  };
};

export const getFirestorePreload = async () => {
  let sites = [];
  let clientGroups = [];
  let practitioners = [];
  let referrers = [];
  let locations = [];
  let clinics = [];
  let admins = [];
  let nurses = [];
  let supervisors = [];
  let specialtyTypes = [];
  let practitionerPreferences = [];
  let specialities = [];
  let specialistSchedulerDescriptions = {};
  let specialistProfiles = [];
  let specialists = {};
  const shouldUsePMSData = process.env.REACT_APP_DATA_SOURCE === "pms-api";
  console.log("process.env.REACT_APP_DATA_SOURCE", process.env.REACT_APP_DATA_SOURCE);
  if (shouldUsePMSData) {
    console.log("Using PMS data");
  } else {
    console.log("Using Core+ data");
  }

  const [
    sitesSnapshot,
    coreplusClientGroupsSnapshot,
    practitionersSnapshot,
    referrersSnapshot,
    locationsSnapshot,
    clinicsSnapshot,
    specialtyTypesSnapshot,
    pmsAdminsSnapshot,
    pmsNursesSnapshot,
    pmsSupervisorsSnapshot,
    practitionerPreferencesSnapshot,
    specialitiesSnapshot,
    practitionerScheduleDescriptionsSnapshot,
    specialistsSnapshot,
    specialistProfilesSnapshot,
  ] = await Promise.all([
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "sites"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "coreplus_client_groups"))),
    FS.getDocs(
      FS.query(
        FS.collection(firebase.modularFirestore(), shouldUsePMSData ? "pms_practitioners" : "coreplus_practitioners")
      )
    ),
    FS.getDocs(
      shouldUsePMSData
        ? FS.query(FS.collection(firebase.modularFirestore(), "pms_referrers"))
        : FS.query(FS.collection(firebase.modularFirestore(), "coreplus_referrers"), FS.where("active", "==", true))
    ),
    FS.getDocs(
      FS.query(FS.collection(firebase.modularFirestore(), shouldUsePMSData ? "pms_locations" : "coreplus_locations"))
    ),
    FS.getDocs(
      shouldUsePMSData
        ? FS.query(FS.collection(firebase.modularFirestore(), "pms_clinics"))
        : FS.query(FS.collection(firebase.modularFirestore(), "coreplus_clinics"), FS.where("active", "==", true))
    ),
    FS.getDocs(
      FS.query(
        FS.collection(firebase.modularFirestore(), shouldUsePMSData ? "pms_specialties" : "coreplus_specialty_types")
      )
    ),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "pms_admins"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "pms_nurses"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "pms_supervisors"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "practitioner_preferences"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "specialities"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "practitioner_schedule_descriptions"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "specialists"))),
    FS.getDocs(FS.query(FS.collection(firebase.modularFirestore(), "specialist_profiles"))),
  ]);
  sitesSnapshot.forEach((doc) => {
    sites.push({ ...doc.data(), id: doc.id });
  });
  coreplusClientGroupsSnapshot.forEach((doc) => {
    clientGroups.push(doc.data());
  });
  specialistsSnapshot.forEach((doc) => {
    specialists[doc.id] = { ...doc.data(), id: doc.id };
  });
  practitionersSnapshot.forEach((doc) => {
    practitioners.push({
      ...doc.data(),
      appointmentLength: specialists[doc.id]?.appointmentLength,
    });
  });
  referrersSnapshot.forEach((doc) => {
    referrers.push(doc.data());
  });
  locationsSnapshot.forEach((doc) => {
    locations.push(doc.data());
  });
  clinicsSnapshot.forEach((doc) => {
    clinics.push(doc.data());
  });
  specialtyTypesSnapshot.forEach((doc) => {
    specialtyTypes.push(doc.data());
  });
  practitionerPreferencesSnapshot.forEach((doc) => {
    practitionerPreferences.push({ ...doc.data(), practitionerId: doc.id });
  });
  specialitiesSnapshot.forEach((doc) => {
    specialities.push({ ...doc.data(), id: doc.id });
  });
  practitionerScheduleDescriptionsSnapshot.forEach((doc) => {
    specialistSchedulerDescriptions[doc.id] = doc.data();
  });
  specialistProfilesSnapshot.forEach((doc) => {
    specialistProfiles.push({ ...doc.data(), id: doc.id });
  });
  pmsAdminsSnapshot.forEach((doc) => {
    admins.push(doc.data());
  });
  pmsNursesSnapshot.forEach((doc) => {
    nurses.push(doc.data());
  });
  pmsSupervisorsSnapshot.forEach((doc) => {
    supervisors.push(doc.data());
  });
  return Promise.resolve({
    sites,
    clientGroups,
    practitioners,
    specialists,
    referrers,
    locations,
    clinics,
    specialtyTypes,
    practitionerPreferences,
    specialities,
    specialistProfiles,
    specialistSchedulerDescriptions,
    admins,
    nurses,
    supervisors,
  });
};
